/* eslint-disable jsx-a11y/label-has-associated-control */
import { Radio } from 'antd'
import { nanoid } from 'nanoid'
import React, { useContext, useEffect, useState } from 'react'
import { MdOutlineCheck } from 'react-icons/md'
import { useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import {
  setJobDomain,
  setSubJob,
} from '../../../../../../redux/reducers/talentSlice'
import { FeathersContext } from '../../../../../../services/feathers'
import { capitalizeAllWords } from '../../../../../../utils/utils'
import * as s from './JobDomain.styles'

const propTypes = {}
const defaultProps = {}

function JobDomain() {
  const feathers = useContext(FeathersContext)
  const { jobDomain, subJob } = useSelector((state) => state.talent)
  const dispatch = useDispatch()
  const [subJobChoices, setSubJobChoices] = useState([])

  const { data: jobs } = useQuery({
    queryFn: async () => {
      const response = await feathers.service('jobs').find({
        query: {
          $limit: 20,
          $sort: {
            name: 1,
          },
        },
      })
      return response.data
    },
    refetchOnWindowFocus: false,
  })

  useEffect(() => {
    if (jobDomain.length === 0) {
      dispatch(setSubJob(''))
    }
  }, [jobDomain, dispatch])

  useEffect(() => {
    if (jobDomain?.length && jobs?.length) {
      const job = jobs?.filter((job) => job.name === jobDomain)

      if (job[0]?.subJobs?.length) {
        setSubJobChoices(job[0].subJobs)
      } else {
        setSubJobChoices([])
      }
    }
  }, [jobDomain, jobs])

  return (
    <s.JobDomainWrapper>
      <label className="field-label">Métiers</label>
      <Radio.Group
        onChange={(e) => {
          dispatch(setJobDomain(e.target.value))
          dispatch(setSubJob(''))
          setSubJobChoices([])
        }}
        defaultValue={jobDomain}
      >
        {jobs
          ?.map((job) => job.name)
          .map((subJob) => (
            <Radio key={nanoid()} value={subJob}>
              {capitalizeAllWords(subJob.toLowerCase())}
            </Radio>
          ))}
      </Radio.Group>
      <div
        style={{ margin: '2rem 0' }}
        className={`subJobs special transition ${
          subJobChoices?.length ? 'transition-fade' : 'transition-hidden'
        }`}
      >
        {subJobChoices?.length > 0 && (
          <>
            <Radio.Group
              onChange={(e) => {
                dispatch(setSubJob(e.target.value))
              }}
              defaultValue={subJob}
            >
              {subJobChoices.map((el) => (
                <Radio.Button key={nanoid()} value={el}>
                  {el === subJob ? (
                    <MdOutlineCheck size={20} />
                  ) : (
                    <MdOutlineCheck size={20} color="white" />
                  )}
                  {capitalizeAllWords(el)}
                </Radio.Button>
              ))}
            </Radio.Group>
          </>
        )}
      </div>
    </s.JobDomainWrapper>
  )
}

JobDomain.propTypes = propTypes
JobDomain.defaultProps = defaultProps

export default JobDomain
